/**
 * Hook to access build-time version metadata injected by Vite.
 *
 * The globals __APP_VERSION__, __GIT_COMMIT__, and __BUILD_TIME__ are defined
 * in vite.config.ts and replaced at build time with string literals.
 */

export interface AppVersionInfo {
  version: string;
  gitCommit: string;
  buildTime: string;
}

export function useAppVersion(): AppVersionInfo {
  return {
    version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev',
    gitCommit: typeof __GIT_COMMIT__ !== 'undefined' ? __GIT_COMMIT__ : 'local',
    buildTime: typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '',
  };
}
